{
  "login": {
    "button_login": "Se Connecter",
    "logout_successful": "Déconnexion réussie",
    "remember_me": "Se souvenir de moi",
    "error": {
      "invalid_username_or_password": "Nom d'utilisateur ou mot de passe incorrect"
    },
    "placeholder": {
      "username": "Nom d'utilisateur",
      "password": "Mot de passe"
    }
  }
}
